
import { LogLevel } from "@azure/msal-browser";

export const msalConfig = {
    auth: {
        clientId: "c2adf07f-653f-45d8-b77a-07e939bcf300",
        authority: "https://login.microsoftonline.com/a9d90964-91d3-4c01-ab00-563f95f00a38",
        redirectUri: "/", 
        postLogoutRedirectUri: "/",
        navigateToLoginRequestUrl: false,
    },
    cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: true, // Set this to "true" if you are having issues on IE11 or Edge
    },
    // system: {
    //     loggerOptions: {
    //         loggerCallback: (level, message, containsPii) => {
    //             if (containsPii) {
    //                 return;
    //             }
    //             switch (level) {
    //                 case LogLevel.Error:
    //                     console.error(message);
    //                     return;
    //                 case LogLevel.Info:
    //                     console.info(message);
    //                     return;
    //                 case LogLevel.Verbose:
    //                     console.debug(message);
    //                     return;
    //                 case LogLevel.Warning:
    //                     console.warn(message);
    //                     return;
    //             }
    //         }
    //     }
    // }
};

export const loginRequest = {
    scopes: ["User.Read"]
};
